import * as React from 'react';
import styled from 'styled-components';

import { colors } from '../styles/variables';
import t from './locales';

const CouponNoticeView = styled.div`
  padding: 8px;
  font-size: 0.8em;
  color: ${colors.gray600};
`;

const CouponNotice = ({ isSelected }: { isSelected: boolean }) => {
  if (!isSelected) { return null; }
  return (
    <CouponNoticeView>
      {t.couponIsSelected()}
      {t.discountAmountWillBeCalculatedInTheNextPage()}
    </CouponNoticeView>
  );
}

export default CouponNotice;
